/**
 * Hide Kapıda Ödeme UI when "İsme Özel" variant is selected.
 */
import { ThemeEvents } from '@theme/events';

const HIDE_VALUE = 'İsme Özel';

function isNameCustomVariant(title) {
  if (!title) return false;
  const value = String(title).trim();
  return value === HIDE_VALUE || value.includes(HIDE_VALUE);
}

function getVariantTitleFromSection(section) {
  const checked = section?.querySelector('variant-picker input[type="radio"]:checked');
  if (checked?.value) return checked.value;

  const selectedOption = section?.querySelector('variant-picker [aria-checked="true"], variant-picker .selected');
  if (selectedOption?.textContent) return selectedOption.textContent.trim();

  const variantJson = section?.querySelector('variant-picker script[type="application/json"]');
  if (variantJson?.textContent) {
    try {
      const variant = JSON.parse(variantJson.textContent);
      return variant?.title || variant?.option1 || '';
    } catch {
      /* ignore */
    }
  }

  return '';
}

function setCodVisible(root, visible) {
  root.querySelectorAll('[data-cod-slot]').forEach((el) => {
    el.classList.toggle('is-hidden', !visible);
    if (visible) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  });
}

function syncSection(section, variantTitle) {
  if (!(section instanceof HTMLElement)) return;
  const title = variantTitle || getVariantTitleFromSection(section);
  setCodVisible(section, !isNameCustomVariant(title));
}

function onVariantUpdate(event) {
  const section = event.target?.closest?.('.shopify-section');
  const title = event.detail?.resource?.title || '';
  if (section) syncSection(section, title);
}

document.addEventListener(ThemeEvents.variantUpdate, onVariantUpdate);

document.querySelectorAll('.shopify-section').forEach((section) => {
  if (section.querySelector('[data-cod-slot]')) syncSection(section);
});
